import React from 'react';

type BetToolbarContextProps = {
  vertical?: boolean;
};

export const BetToolbarContext = React.createContext<BetToolbarContextProps>({
  vertical: undefined,
});
